module.exports = __webpack_public_path__ + "img/NORDIC_WHOLE_GRAINS.62ae854c.png";